import React from 'react'
import Story from './story'
import Entity from '../Entity';

class ArticleStory extends Story {
  constructor(props) {
    super(props);

    this.state = {
      story: props.story,
      entity: props.story.entity,
      payload: props.story.payload,
      article: props.story.payload[0],
    }
  }

  render() {
    const tracking = '?ad_medium=myad_feed&ad_name=article-story';
    const article = this.state.article;
    const subtitleMsg = I18n.t('jslibrary.stream.because_follow');
    
    if(!article.title || !article.url || !article.image) return null;

    return (
      <div className="afd-story" data-insights-category="myad-feed" data-insights-label="article-story" data-insights-value={article.url}>
        <header className="afd-story__content">
          <h2 className="afd-title-big afd-title-big--bmargin-big afd-container-padding--m">
            <a className="afd-title--black-link" href={article.url + tracking}>
              {article.title}
            </a>
          </h2>
          <div className="date-publication afd-mobile-margin">
            {this.formatDate(this.state.story.created_at)} | {subtitleMsg} <Entity entity={this.state.entity}/>
          </div>
        </header>

        <div className="afd-story__content">
          <figure className="afd-figure">
            <a href={article.url + tracking}>
              <img src={article.image.replace('http://', 'https://').replace('.qtlcn.com','')} className="afd-figure__image"/>
            </a>
          </figure>
        </div>
      </div>
    )
  }
}

export default ArticleStory;